import React, { FC } from 'react';

import { pharmacistBooking, TypeOfBill } from '@pharmaplan/common';

import LongTermBillDetails from '../../SelfService/LongTermBillDetails';
import { useAppSelector } from '../../../hooks/useAppSelector';
import BillDetails from '../../SelfService/BillDetails';
import strings from '../../../localization';
import useSelfService from '../../../hooks/useSelfService';

interface IPharmacyBookingDetails {
  successAction: string;
}

const PharmacyBookingBillDetails: FC<IPharmacyBookingDetails> = ({
  successAction,
}) => {
  const details = useAppSelector(pharmacistBooking);
  const { isSelfService } = useSelfService();

  const {
    cost,
    accommodationCosts,
    longTermShiftContract,
    totalWeekHours = '',
    totalWeekendHours = '',
    pharmacyWeekDayHourlyRate = 0,
    pharmacyWeekendHourlyRate = 0,
  } = details ?? {};

  const { longTermShiftContractId } = longTermShiftContract ?? {};

  const fullEvent = {
    ...details,
    accommodationAllowance: accommodationCosts,
    cost,
  };

  const pharmacistDetails = {
    longTermShiftContract,
    totalWeekHours,
    totalWeekendHours,
  };

  const pharmacyDetails = {
    longTermShiftContract: {
      weekDayPaidHourlyRate: pharmacyWeekDayHourlyRate,
      weekendPaidHourlyRate: pharmacyWeekendHourlyRate,
    },
    totalWeekHours,
    totalWeekendHours,
  };

  return longTermShiftContractId ? (
    <>
      <LongTermBillDetails
        successAction={successAction}
        customTitle={
          strings.formatString(
            strings.userBillDetails,
            strings.professional,
          ) as string
        }
        details={pharmacistDetails}
      />
      {!isSelfService && (
        <LongTermBillDetails
          successAction={successAction}
          customTitle={
            strings.formatString(
              strings.userBillDetails,
              strings.pharmacy,
            ) as string
          }
          details={pharmacyDetails}
        />
      )}
    </>
  ) : (
    <BillDetails
      billType={TypeOfBill.bill}
      event={fullEvent}
      successAction={successAction}
    />
  );
};

export default PharmacyBookingBillDetails;
